/* eslint-disable react/prop-types */
// @ts-nocheck
import React, {useEffect, useState, createContext, useLayoutEffect} from "react";
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Redirect,
    useLocation
} from "react-router-dom";
import {Provider, useSelector} from "react-redux";
import {PersistGate} from "redux-persist/integration/react";
import CssBaseline from "@material-ui/core/CssBaseline";
// import {store, persistor} from "./redux/store";
import adminStore from "./redux/adminStore";
// import { createHashHistory } from "history";
import {createBrowserHistory} from "history";
import ReduxThemeProvider from "./theme";
import branch from "branch-sdk";
import {api_getUserByID} from "./redux/user/user.api";

import * as LogRocket from "logrocket";
//components
import {
    Header,
    VetConfirmation,
    Auth,
} from "./Components";

//Pages
import {
    VetProfile,
    UserSignUp,
    PartnerSignUp,
    AskRalphie,
    DashboardProfile,
    Login,
    Schedule,
    PetEdit,
    Pets,
    ResetPassword,
    ForgotPassword,
    ForgotPasswordSuccess,
    AvaliableVet,
    Page404,
    PastAppointments,
    UpcomingAppointments,
    AppointmentRate,
    AppointmentNotes,
    PartnerPreferences,
    AppointmentSummary,
    AppointmentPrescription,
    CreditSummary,
    PurchaseCredits,
    GeneralInfo,
    MedicalRecords,
    MedicalConditions,
    NoRxDisclaimer,
    PartnerDashboard,
    AdminPage,
    UserOnboardingFlow,
    InformedConsentPage,
    SubscriptionPay,
    Gifts,
    Referrals,
    SubscriptionDetails,
	PaymentInformation,
    BookAgain, BeforeLogin,
    ChatRoom,
    JoinRoom,
    GuestAvailableVet
} from "./Pages";
import PrivateRoute from "./Components/PrivateRoute";
import AdminRoute from "./Components/AdminRoute";
import Pay from "./Pages/Pay";
import IsOnBoardingCheck from "./Pages/IsOnBoardingCheck";
import API from "./helpers/apiHelpers";
import Invoice from "./Pages/Invoice";
import ResetPasswordError from "./Pages/ResetPasswordError/ResetPasswrodError";
import {MuiPickersUtilsProvider} from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";

//for the data provider/admin page:
import adminAPI from "./helpers/dataProvider";
import polyglotI18nProvider from "ra-i18n-polyglot";
import AgoraRTC from "agora-rtc-sdk-ng";
import BeforeUnloadDialog from "./Components/BeforeUnloadDialog";
import IsLoggedInCheck from "./Pages/IsLoggedInCheck/IsLoggedInCheck";
import {useMediaQuery, useTheme} from "@material-ui/core";
import VetSchedule from "./Components/Forms/VetSchedule";

AgoraRTC.setLogLevel(3);

export const IsOnBoardingContext = createContext<Partial<{ isOnBoarding: boolean, setIsOnBoarding: React.Dispatch<React.SetStateAction<boolean>> }>>({});
const historyHash = createBrowserHistory({basename: "/admin"});
const dataProvider = adminAPI({
    total: null
});
const {store, persistor} = adminStore({dataProvider, historyHash});

declare global {
    interface Window {
        Intercom: any;
    }
}

const TidioVisibility = () => {
    const location = useLocation();

    useEffect(() => {
        const hiddenPaths = [
            "/chat",
            "/joinRoom",
            "/schedule",
            "/guest/book",
            "/call",
            "/appointments"
        ];

        const shouldHide = hiddenPaths.some(path =>
            location.pathname.startsWith(path)
        );

        const updateTidioVisibility = () => {
            const tidio = document.querySelector("#tidio-chat") as HTMLElement;

            if (tidio) {
                tidio.style.setProperty(
                    "display",
                    shouldHide ? "none" : "",
                    "important"
                );
            }
        };

        updateTidioVisibility();

        const observer = new MutationObserver(() => {
            updateTidioVisibility();
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });

        return () => {
            observer.disconnect();
        };
    }, [location.pathname]);

    return null;
};

const App = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const [isOnBoarding, setIsOnBoarding] = useState(!!document.cookie.replace(/(?:(?:^|.*;\s*)isOnBoarding\s*\=\s*([^;]*).*$)|^.*$/, "$1"));
    LogRocket.init(process.env.REACT_APP_LOG_ROCKET);
    const i18nProvider = polyglotI18nProvider(() => null, "en", {
        allowMissing: true,
        onMissingKey: (key, _, __) => key
    });
    let currentPath = window.location.search;
    useEffect(() => {
        ["benefits", "gift"].map(item => {
            if (window.location.search.includes(item)) {
                const value = item === "benefits" ? "subscription" : item;
                window.sessionStorage.setItem("specialParams", value);
            }
        });
    }, []);


    useEffect(() => {
        if (API.token) {
            API.getProfiles({
                userId: API.userId
            }).then((profile) => {
                if (!profile.length) {
                    setIsOnBoarding(true);
                } else {
                    setIsOnBoarding(false);
                }
            });
        }

        branch.init(process.env.REACT_APP_BRANCH_KEY, (err, data) => {
            branch.data((err, data) => {
                if (data) {
                    const promoBranch = data.data_parsed.promo;
                    if (promoBranch) {
                        sessionStorage.setItem("promoBranch", promoBranch);
                    }
                }
            });
        });
    }, []);

    return (
        <IsOnBoardingContext.Provider value={{isOnBoarding: isOnBoarding, setIsOnBoarding: setIsOnBoarding}}>
            <CssBaseline/>
            <Provider store={store}>
                <PersistGate loading={null} persistor={persistor}>
                    <ReduxThemeProvider>
                        <Router>
                            <TidioVisibility />

                            {!currentPath.includes("?noheader") &&
                            <Header/>
                            }
                            <BeforeUnloadDialog />
                            <Switch>
                                <PrivateRoute exact path="/schedule">
                                    <Schedule/>
                                </PrivateRoute>
                                <PrivateRoute exact path="/bookAgain">
                                    <BookAgain/>
                                </PrivateRoute>
                                <PrivateRoute exact path="/apointmentRate">
                                    <AppointmentRate userType={API.role}/>
                                </PrivateRoute>
                                <PrivateRoute exact path="/apointmentNotes">
                                    <AppointmentNotes userType={API.role}/>
                                </PrivateRoute>
                                <PrivateRoute exact path="/apointmentPrescriptions">
                                    <AppointmentPrescription userType={API.role}/>
                                </PrivateRoute>
                                <PrivateRoute exact path="/availableVet">
                                    <AvaliableVet/>
                                </PrivateRoute>
                                <PrivateRoute path="/availableVet/:profileId">
                                    <VetProfile/>
                                </PrivateRoute>
                                <PrivateRoute path="/appointmentConfirmation">
                                    <VetConfirmation/>
                                </PrivateRoute>
                                <PrivateRoute path="/dashboardProfile">
                                    <MuiPickersUtilsProvider utils={MomentUtils}>
                                        <DashboardProfile/>
                                    </MuiPickersUtilsProvider>
                                </PrivateRoute>
                                <PrivateRoute path="/VetSchedule">
                                    <MuiPickersUtilsProvider utils={MomentUtils}>
                                        <VetSchedule/>
                                    </MuiPickersUtilsProvider>
                                </PrivateRoute>
                                <PrivateRoute exact path="/pets">
                                    <Pets/>
                                </PrivateRoute>
                                <PrivateRoute exact path="/pets/:petId">
                                    <IsOnBoardingContext.Consumer>{
                                        ({isOnBoarding, setIsOnBoarding}) => <PetEdit isOnBoarding={isOnBoarding}
                                            setIsOnBoarding={setIsOnBoarding}/>
                                    }</IsOnBoardingContext.Consumer>
                                </PrivateRoute>
                                <PrivateRoute path="/pets/:petId/general">
                                    <IsOnBoardingContext.Consumer>{
                                        ({isOnBoarding, setIsOnBoarding}) => <GeneralInfo isOnBoarding={isOnBoarding}
                                            setIsOnBoarding={setIsOnBoarding}/>
                                    }</IsOnBoardingContext.Consumer>
                                </PrivateRoute>
                                <PrivateRoute path="/pets/:petId/medicalRecords">
                                    <MedicalRecords/>
                                </PrivateRoute>
                                <PrivateRoute path="/pets/:petId/medicalConditions">
                                    <MedicalConditions/>
                                </PrivateRoute>
                                <PrivateRoute path="/preferences">
                                    <PartnerPreferences/>
                                </PrivateRoute>
                                <Route exact path="/appConsent">
                                    <InformedConsentPage/>
                                </Route>
                                <PrivateRoute path="/consent">
                                    <InformedConsentPage/>
                                </PrivateRoute>
                                <PrivateRoute path="/partnerDashboard">
                                    <MuiPickersUtilsProvider utils={MomentUtils}>
                                        <PartnerDashboard/>
                                    </MuiPickersUtilsProvider>
                                </PrivateRoute>
                                <PrivateRoute exact path="/creditSummary">
                                    <CreditSummary/>
                                </PrivateRoute>
                                <PrivateRoute exact path="/purchaseCredits">
                                    <IsOnBoardingContext.Consumer>{
                                        ({isOnBoarding}) => <PurchaseCredits isOnBoarding={isOnBoarding}
                                            setIsOnBoarding={setIsOnBoarding}/>
                                    }</IsOnBoardingContext.Consumer>
                                </PrivateRoute>
                                <PrivateRoute path="/appointments" exact>
                                    <MuiPickersUtilsProvider utils={MomentUtils}>
                                        <UpcomingAppointments/>
                                    </MuiPickersUtilsProvider>
                                </PrivateRoute>
                                <PrivateRoute path="/summary" exact>
                                    <AppointmentSummary/>
                                </PrivateRoute>
                                <PrivateRoute path="/appointments/past">
                                    <PastAppointments/>
                                </PrivateRoute>
                                <PrivateRoute path="/chat">
                                    <ChatRoom/>
                                </PrivateRoute>
                                <PrivateRoute path="/joinRoom">
                                    <JoinRoom/>
                                </PrivateRoute>
                                <PrivateRoute path="/referrals">
                                    <Referrals/>
                                </PrivateRoute>
                                <PrivateRoute path="/paymentInformation">
                                    <PaymentInformation />
                                </PrivateRoute>
                                <PrivateRoute path="/gift">
                                    <Gifts/>
                                </PrivateRoute>
                                <PrivateRoute path="/subscription">
                                    <SubscriptionPay/>
                                </PrivateRoute>
                                <PrivateRoute path="/subscriptionDetails">
                                    <SubscriptionDetails/>
                                </PrivateRoute>
                                <PrivateRoute path="/pay/:price">
                                    <Pay/>
                                </PrivateRoute>
                                <Route path="/" exact>
                                    <IsOnBoardingContext.Consumer>{
                                        ({isOnBoarding}) => <IsOnBoardingCheck isOnBoarding={isOnBoarding}/>
                                    }</IsOnBoardingContext.Consumer>
                                </Route>
                                <PrivateRoute path="/disclaimer">
                                    <NoRxDisclaimer/>
                                </PrivateRoute>
                                <PrivateRoute path="/invoice">
                                    <Invoice/>
                                </PrivateRoute>
                                <Route path="/askRalphie">
                                    <AskRalphie/>
                                </Route>
                                <Route exact path="/guest/book">
                                    <GuestAvailableVet/>
                                </Route>
                                <Route exact path="/login">
                                    <Auth>
                                        <IsLoggedInCheck />
                                    </Auth>
                                </Route>
                                <AdminRoute path="/admin/">
                                    <MuiPickersUtilsProvider utils={MomentUtils}>
                                        <AdminPage dataProvider={dataProvider} historyHash={historyHash}
                                            i18nProvider={i18nProvider}/>
                                    </MuiPickersUtilsProvider>
                                </AdminRoute>
                                <Route path="/signUp">
                                    <Auth>
                                        <IsOnBoardingContext.Consumer>{
                                            ({setIsOnBoarding}) => <UserSignUp setIsOnBoarding={setIsOnBoarding}/>
                                        }</IsOnBoardingContext.Consumer>
                                    </Auth>
                                </Route>
                                <Route path="/gettingStarted">
                                    <Auth>
                                        <MuiPickersUtilsProvider utils={MomentUtils}>
                                            <IsOnBoardingContext.Consumer>{
                                                ({setIsOnBoarding}) => <UserOnboardingFlow isOnBoarding={isOnBoarding}
                                                    setIsOnBoarding={setIsOnBoarding}/>
                                            }</IsOnBoardingContext.Consumer>
                                        </MuiPickersUtilsProvider>
                                    </Auth>
                                </Route>
                                <Route path="/adminSignUp">
                                    <Auth>
                                        {(API.isLoggedIn && !isOnBoarding) ? <Redirect to="/"/> : (
                                            <IsOnBoardingContext.Consumer>{
                                                ({setIsOnBoarding}) => <PartnerSignUp
                                                    setIsOnBoarding={setIsOnBoarding}/>
                                            }</IsOnBoardingContext.Consumer>
                                        )}
                                    </Auth>
                                </Route>
                                <Route path="/forgotPassword">
                                    <Auth>
                                        <ForgotPassword/>
                                    </Auth>
                                </Route>
                                <Route path="/forgotPasswordSuccess">
                                    <Auth>
                                        <ForgotPasswordSuccess/>
                                    </Auth>
                                </Route>
                                <Route path="/resetPassword">
                                    <Auth>
                                        <ResetPassword/>
                                    </Auth>
                                </Route>
                                <Route path="/welcome">
                                    <Auth>
                                        <BeforeLogin/>
                                    </Auth>
                                </Route>
                                <Route path="/resetPasswordError">
                                    <Auth>
                                        <ResetPasswordError/>
                                    </Auth>
                                </Route>
                                <Route path="/logout">
                                    <Redirect to="/"/>
                                </Route>
                                <Route>
                                    <Page404/>
                                </Route>
                            </Switch>
                        </Router>
                    </ReduxThemeProvider>
                </PersistGate>
            </Provider>
        </IsOnBoardingContext.Provider>
    );
};
export default App;
